/* global graphql */
import "babel-polyfill";
import React, { PureComponent } from "react";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import Waypoint from "react-waypoint";
import CaseStudyBlock from "../components/CaseStudyBlock";
import CaseStudyBlockText from "../components/CaseStudyBlockText";
import ScrollBar from "../components/ScrollBar";
import findIn from "../utils/findPolyfill";

class Index extends PureComponent {
  constructor(props) {
    super(props);

    this.handleStudyChange = this.handleStudyChange.bind(this);

    const { data } = props;
    const { allPage } = data;
    const aboutPage = {
      id: "about",
      title: "Quality is in the details",
      headerPhoto: "",
      route: "/about"
    };
    const pages = [aboutPage].concat(allPage.edges.map(e => e.node));

    this.state = {
      currentPage: pages[0].id
    };
  }

  handleStudyChange(id) {
    this.setState({
      currentPage: id
    });
  }

  render() {
    const { currentPage } = this.state;
    const { data } = this.props;
    const { allPage } = data;
    const aboutPage = {
      id: "about",
      title: "Quality is in the details",
      headerPhoto:
        "https://s3.amazonaws.com/mobelux-morty/uploads/gulf-seaboard/about/dsc_4696_edit.jpg",
      route: "/about"
    };

    const pages = [aboutPage].concat(allPage.edges.map(e => e.node));
    const current = findIn(pages, page => page.id === currentPage);

    const caseStudies = pages.map(page =>
      <Waypoint
        key={page.id}
        bottomOffset="30%"
        topOffset="40%"
        onEnter={() => {
          this.handleStudyChange(page.id);
        }}
      >
        <div className="h-100 relative" style={{ left: "-15px" }}>
          <CaseStudyBlockText study={page} isCurrent={page.id == currentPage} />
        </div>
      </Waypoint>
    );

    return (
      <div>
        <Helmet>
          <title>Gulf Seaboard</title>
        </Helmet>
        {/* background color + photo */}
        <CaseStudyBlock currentPage={current} allPages={pages} />
        {/* scrollBar */}
        <ScrollBar length={pages.length} currentPage={current} />
        {/* text */}
        <div className="absolute w-100 vh-100 bg-fade flex items-center w-100">
          <div
            className="fixed overflow-container top-0 ease-reg h-100 w-100"
            style={{ right: "-15px" }}
          >
            {caseStudies}
          </div>
        </div>
      </div>
    );
  }
}

Index.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.shape({
    allCaseStudies: PropTypes.object
  })
};

export default Index;

export const pageQuery = graphql`
  query featuredCaseStudies {
    allPage(limit: 3) {
      edges {
        node {
          id
          title
          headerPhoto
          route
          template
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js